import React from 'react'

export default function Loader(props) {

    function renderFullPageLoader(){
        if(!props.show){
            return null;
        }


        return(
            <section className="qloader active">
                <div className="loader-circle"></div>
                <div className="loader-line-mask">
                    <div className="loader-line"></div>
                </div>
            </section>
        )

    }
    return renderFullPageLoader()
}
